import moment from 'moment';
import { IKpiSnapshot } from '@/types/response';

export interface IInitiativeImpact {
  /** 施策の前7日（前日の値 − 8日前の値） */
  before: number | null;
  /** 施策の日を含む後7日（6日後の値 − 前日の値）。まだ7日経っていなければ null */
  after: number | null;
}

/**
 * 施策の前後7日で複数人家族がいくつ増えたか。施策の日から効くものとして、
 * その前日の値を境目にする。どちらかの端の日の集計が無ければ null（0 ではない）。
 */
export const initiativeImpact = (
  rows: IKpiSnapshot[],
  date: string,
): IInitiativeImpact => {
  const byDate = new Map<string, number>();
  rows.forEach((r) => {
    const v = r.daily.multiMemberFamilies;
    if (typeof v === 'number') byDate.set(r.targetDate, v);
  });

  const at = (offset: number) =>
    byDate.get(
      moment(date, 'YYYY-MM-DD').add(offset, 'days').format('YYYY-MM-DD'),
    );
  const diff = (to: number | undefined, from: number | undefined) =>
    typeof to === 'number' && typeof from === 'number' ? to - from : null;

  return { before: diff(at(-1), at(-8)), after: diff(at(6), at(-1)) };
};
